import { render } from "./DependentView.vue?vue&type=template&id=0cb5f1fe&scoped=true"
import script from "./DependentView.vue?vue&type=script&lang=js"
export * from "./DependentView.vue?vue&type=script&lang=js"

import "./DependentView.vue?vue&type=style&index=0&id=0cb5f1fe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb5f1fe"]])

export default __exports__